// avstemming-equity-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'avbe.page.noAccount': 'El área de patrimonio neto no tiene ninguna cuenta de conciliación en este período.',
  'avbe.accountingData': 'Datos contables',
  'avbe.statement.title': 'Estado de cambios en el patrimonio neto',
  'avbe.nav.differences': '{count} diferencia',
  'avbe.reconciled': 'Conciliado',
  'avbe.changes.title': 'Cambios en el patrimonio neto',
  'avbe.nav.movements': '{count} movimientos',
  'avbe.capital.title': 'Capital y propietarios',
  'avbe.nav.equityLiquidity': 'Patrimonio neto y liquidez',
  'avbe.nav.documentation': 'Documentación',
  'avbe.nav.missing': '{count} faltan',
  'avbe.complete': 'Completo',
  'avbe.nav.itemsToAssess': 'Asuntos por evaluar',
  'avbe.nav.open': '{count} abiertos',
  'avbe.nav.controls': 'Control y aprobación',
  'avbe.areaLabel': 'Patrimonio neto',
  'avbe.page.hintOpen': '{count} asuntos con aviso aún no se han evaluado por completo.',
  'avbe.page.hintAllDone': 'Todos los asuntos con aviso están evaluados.',
  'avbe.page.heading': 'Patrimonio neto: estado, acuerdos y solvencia',
  'avbe.responsible': 'Responsable: {name}',
  'avbe.page.distNoBasis': 'Distribuciones sin base de decisión: {count}',
  'avbe.itemsNeedAssessment': '{count} asuntos requieren evaluación',
  'avbe.page.noOpenItems': 'Sin asuntos abiertos',
  'avbe.page.unexplainedDiff': 'El estado de cambios en el patrimonio neto tiene una diferencia de cálculo sin explicar de {amount}.',
  'avbe.page.noCalcDeviation': 'El patrimonio neto está conciliado sin desviaciones de cálculo.',
  'avbe.page.lossReduced': 'La pérdida del período ha reducido el patrimonio neto en {amount}.',
  'avbe.page.profitIncreased': 'El beneficio del período ha aumentado el patrimonio neto en {amount}.',
  'avbe.page.distMissingOne': 'Falta la base de decisión en {count} distribución.',
  'avbe.page.distMissingMany': 'Falta la base de decisión en {count} distribuciones.',
  'avbe.page.ytdNote': 'El patrimonio neto se concilia en lo que va de año: el saldo inicial al comienzo del ejercicio, los movimientos hasta el cierre del período y el saldo final al cierre del período. La app no obtiene el capital social registrado ni los cambios de capital del Foretaksregisteret, y deben comprobarse manualmente.',
  'avbe.sources.title': 'Fuentes de datos',
  'avbe.sources.missingOne': 'Falta {count} fuente para el ejercicio.',
  'avbe.sources.missingMany': 'Faltan {count} fuentes para el ejercicio.',
  'avbe.sources.allInPlace': 'Las fuentes que lee la conciliación están disponibles para el ejercicio.',
  'avbe.sources.source': 'Fuente',
  'avbe.status': 'Estado',
  'avbe.details': 'Detalles',
  'avbe.sources.unavailable': 'No disponible',
  'avbe.sources.incomplete': 'Incompleto',
  'avbe.requestDocsClient': 'Pedir documentación al cliente',
  'avbe.group.paidIn': 'Patrimonio neto aportado',
  'avbe.group.retained': 'Patrimonio neto generado',
  'avbe.overview.readFromLedger': 'Leído del libro mayor el {date}',
  'avbe.overview.bookedEquity': 'Patrimonio neto contabilizado en cuentas de patrimonio neto',
  'avbe.overview.accumulatedResult': 'Resultado acumulado del período',
  'avbe.overview.transferred': 'Traspasado al patrimonio neto',
  'avbe.overview.notTransferred': 'No traspasado',
  'avbe.overview.computedInclResult': 'Patrimonio neto calculado incl. resultado',
  'avbe.overview.previousEquity': 'Patrimonio neto del período anterior',
  'avbe.overview.equityChange': 'Variación del patrimonio neto',
  'avbe.equityRatio': 'Ratio de patrimonio neto',
  'avbe.overview.ratioSub': 'Se evalúa junto con el riesgo y la liquidez',
  'avbe.overview.hideAccounts': 'Ocultar resumen de cuentas',
  'avbe.overview.showAccounts': 'Mostrar resumen de cuentas',
  'avbe.account': 'Cuenta',
  'avbe.opening': 'Saldo inicial',
  'avbe.additions': 'Altas',
  'avbe.disposals': 'Bajas',
  'avbe.closing': 'Saldo final',
  'avbe.change': 'Variación',
  'avbe.vouchers': 'Justificantes',
  'avbe.tile.noVoucher': 'Movimiento sin respaldo en justificantes',
  'avbe.matches': 'Coincide',
  'avbe.overview.accountsNote': 'Las altas y las bajas son la suma de los justificantes de la cuenta en lo que va de año. El saldo final es el del balance de comprobación.',
  'avbe.tile.noDecisionBasis': 'Distribución sin base de decisión',
  'avbe.tile.calcDifference': 'Diferencia de cálculo en el estado',
  'avbe.tile.directPosting': 'Contabilización directa en patrimonio neto',
  'avbe.tile.ownerTransaction': 'Transacción con el propietario',
  'avbe.tile.negativeEquity': 'Patrimonio neto negativo',
  'avbe.tile.noShareCapital': 'Sin capital social contabilizado',
  'avbe.tile.noShareRegister': 'Libro registro de acciones no registrado',
  'avbe.control.title': 'Tarjeta de control',
  'avbe.control.summary': '{checks} controles automáticos ejecutados · {flagged} asuntos requieren evaluación · {done} evaluados',
  'avbe.control.categoriesReconciled': 'Categorías de patrimonio neto conciliadas',
  'avbe.control.categoriesOf': '{done} de {total}',
  'avbe.control.categoriesSub': 'Saldo final calculado frente al contabilizado',
  'avbe.itemsRequireAssessment': 'Asuntos que requieren evaluación',
  'avbe.control.foundNothing': 'Los controles no encontraron nada',
  'avbe.control.activeFilter': 'Filtro activo: {label} · {count} asuntos',
  'avbe.control.reset': 'Restablecer',
  'avbe.checks.title': 'Controles automáticos',
  'avbe.checks.note': 'Los controles no marcan nada en la lista de comprobación profesional. Indican qué debería haber revisado quien la marca.',
  'avbe.checks.check': 'Control',
  'avbe.checks.run': 'Ejecución',
  'avbe.checks.findings': 'Hallazgos',
  'avbe.checks.ran': 'Ejecutado',
  'avbe.checks.findingsCount': '{count} hallazgos',
  'avbe.checks.noFindings': 'Sin hallazgos',
  'avbe.statement.ytd': 'En lo que va de año · {from}–{to}',
  'avbe.statement.category': 'Categoría de patrimonio neto',
  'avbe.statement.periodResult': 'Resultado del período',
  'avbe.statement.computedClosing': 'Saldo final calculado',
  'avbe.statement.booked': 'Contabilizado',
  'avbe.difference': 'Diferencia',
  'avbe.mustAssess': 'Requiere evaluación',
  'avbe.statement.zeroRows': '{count} categorías de patrimonio neto restantes no tienen saldo ni movimientos.',
  'avbe.statement.showZero': 'Mostrar {count} partidas a cero',
  'avbe.statement.noBalance': 'Sin saldo',
  'avbe.statement.hideZero': 'Ocultar partidas a cero',
  'avbe.statement.sumBooked': 'Suma de cuentas de patrimonio neto contabilizadas',
  'avbe.statement.resultTransferred': 'Resultado del período traspasado al patrimonio neto',
  'avbe.statement.resultNotTransferred': 'Resultado del período no traspasado',
  'avbe.statement.computedInclResult': 'Patrimonio neto calculado incluido el resultado',
  'avbe.statement.noteTransferred': 'El resultado del período se ha traspasado a las cuentas de patrimonio neto y por eso no se suma de nuevo en el cálculo.',
  'avbe.statement.noteNotTransferred': 'El resultado del período no se ha traspasado a las cuentas de patrimonio neto y por eso se suma al patrimonio neto calculado. No se cuenta dos veces.',
  'avbe.statement.notePrevYear': 'El resultado del año anterior ya está incluido en el patrimonio neto inicial. La aplicación del resultado reparte el importe entre dividendos y otro patrimonio neto generado sin volver a sumar el resultado.',
  'avbe.changes.countOne': '{count} movimiento en lo que va de año',
  'avbe.changes.countMany': '{count} movimientos en lo que va de año',
  'avbe.changes.none': 'No se ha contabilizado ninguna transacción de patrimonio neto en lo que va de año.',
  'avbe.date': 'Fecha',
  'avbe.type': 'Tipo',
  'avbe.description': 'Descripción',
  'avbe.amount': 'Importe',
  'avbe.category': 'Categoría',
  'avbe.changes.counterAccount': 'Contrapartida',
  'avbe.changes.decisionDate': 'Fecha del acuerdo',
  'avbe.changes.decisionBasis': 'Base de decisión',
  'avbe.changes.noCounterTitle': 'El justificante no tiene contrapartida fuera del patrimonio neto',
  'avbe.changes.noCounter': 'Sin contrapartida',
  'avbe.changes.notRequired': 'No requerido',
  'avbe.documented': 'Documentado',
  'avbe.missing': 'Falta',
  'avbe.changes.noAlert': 'Sin aviso',
  'avbe.assessed': 'Evaluado',
  'avbe.seeAssessment': 'Ver evaluación',
  'avbe.assess': 'Evaluar',
  'avbe.changes.requestMinutes': 'Pedir el acta',
  'avbe.changes.note': 'Las evaluaciones no contabilizan nada. Una corrección se hace en el justificante, y una distribución sin acuerdo se resuelve con el acta, no con una marca aquí.',
  'avbe.quick.needsAssessment': 'Requiere evaluación',
  'avbe.assessedDone': 'Evaluado',
  'avbe.quick.all': 'Todos',
  'avbe.items.resetFilters': 'Restablecer filtros',
  'avbe.items.noneInFilter': 'No hay asuntos en este filtro.',
  'avbe.items.noneFound': 'Los controles no encontraron asuntos que requieran evaluación.',
  'avbe.items.item': 'Asunto',
  'avbe.items.alert': 'Aviso',
  'avbe.assessment': 'Evaluación',
  'avbe.action': 'Medida',
  'avbe.capital.limitedCompany': 'Sociedad anónima',
  'avbe.capital.legalFormUnset': 'Forma jurídica no definida',
  'avbe.capital.bookedShareCapital': 'Capital social contabilizado',
  'avbe.capital.bookedPremium': 'Prima de emisión contabilizada',
  'avbe.capital.ownShares': 'Acciones propias',
  'avbe.capital.sharesInRegister': 'Número de acciones en el libro registro de acciones',
  'avbe.capital.shareholderCount': 'Número de accionistas',
  'avbe.capital.nominal': 'Valor nominal por acción',
  'avbe.capital.registeredCapital': 'Capital social registrado (Foretaksregisteret)',
  'avbe.notFetched': 'La app no lo obtiene',
  'avbe.capital.articles': 'Estatutos',
  'avbe.capital.notUploaded': 'No subido',
  'avbe.capital.agmRecorded': 'Junta general registrada',
  'avbe.capital.notRecorded': 'No registrada',
  'avbe.capital.notFetchedNote': 'Plumme no obtiene el capital social registrado, los cambios de capital ni el extracto del registro de accionistas. El capital social contabilizado debe comprobarse manualmente con el Foretaksregisteret y los estatutos.',
  'avbe.capital.shareholder': 'Accionista',
  'avbe.capital.shares': 'Acciones',
  'avbe.capital.share': 'Participación',
  'avbe.capital.noRegister': 'No hay ningún libro registro de acciones en Plumme.',
  'avbe.capital.noRegisterHint': 'Pide el libro registro de acciones al cliente, o registra a los propietarios en el cierre anual.',
  'avbe.disp.title': 'Aplicación del resultado de {year}',
  'avbe.disp.resolutionRecorded': 'Acuerdo registrado',
  'avbe.disp.mathMatchesNoResolution': 'La contabilización cuadra matemáticamente, pero falta el acuerdo',
  'avbe.disp.bookedDeviates': 'La aplicación contabilizada difiere del resultado del ejercicio',
  'avbe.disp.noneBooked': 'Sin aplicación del resultado contabilizada',
  'avbe.disp.item': 'Partida',
  'avbe.disp.proposed': 'Propuesto',
  'avbe.disp.resolved': 'Acordado',
  'avbe.disp.notVerified': 'No verificado',
  'avbe.disp.prevResultUnreadable': 'No se pudo leer el resultado del ejercicio anterior, por lo que la aplicación no se puede comparar con él.',
  'avbe.disp.sumsToResult': 'La aplicación contabilizada suma el resultado del año anterior.',
  'avbe.disp.notSumsToResult': 'La aplicación contabilizada no suma el resultado del año anterior.',
  'avbe.disp.noneBookedYtd': 'No se ha contabilizado ninguna aplicación del resultado en lo que va de año.',
  'avbe.disp.resolutionRecordedAt': 'El acuerdo está registrado en la junta general del {date}.',
  'avbe.disp.cannotVerify': 'La aplicación acordada no se puede verificar hasta que se registre la junta general o se reciba el acta.',
  'avbe.disp.requestAgmMinutes': 'Pedir al cliente el acta de la junta general',
  'avbe.liq.title': 'Evaluación del patrimonio neto y la liquidez',
  'avbe.liq.documented': 'Evaluación documentada',
  'avbe.computedEquity': 'Patrimonio neto calculado',
  'avbe.liq.changeSincePrevious': 'Variación desde el período anterior',
  'avbe.liq.workingCapital': 'Capital circulante',
  'avbe.liq.liquidAssets': 'Fondos líquidos',
  'avbe.liq.overduePayables': 'Deuda vencida con proveedores',
  'avbe.liq.items': '{count} partidas',
  'avbe.yes': 'Sí',
  'avbe.no': 'No',
  'avbe.liq.bankData': 'Datos bancarios del ejercicio',
  'avbe.liq.budgetAvailable': 'Presupuesto disponible',
  'avbe.liq.forecastAvailable': 'Previsión de liquidez disponible',
  'avbe.liq.noteSoundness': 'La evaluación de un patrimonio neto y una liquidez adecuados debe verse en el contexto del riesgo, el volumen, la liquidez y las perspectivas de futuro de la empresa. Plumme aporta la base; la evaluación la hacen el consejo de administración y el contable.',
  'avbe.liq.noteFuture': 'La evolución futura no se puede evaluar solo con las cifras: no hay presupuesto ni previsión de liquidez para el ejercicio.',
  'avbe.liq.confirmation': 'Evaluación y confirmación del consejo de administración',
  'avbe.liq.confirmationRequired': 'Evaluación y confirmación del consejo de administración (obligatoria)',
  'avbe.liq.confirmationPlaceholder': '¿Qué muestra la revisión y qué ha confirmado el consejo de administración? Remite al acta del consejo o a una confirmación escrita.',
  'avbe.savedAsReason': 'Se guarda como justificación del punto de control «{label}».',
  'avbe.liq.requestBoardAssessment': 'Pedir al cliente la evaluación del consejo de administración',
  'avbe.docs.title': 'Documentación y base de decisión',
  'avbe.docs.basis': 'Base',
  'avbe.docs.inPlace': 'Disponible',
  'avbe.requestDocsCustomer': 'Pedir documentación al cliente',
  'avbe.docs.attached': 'Documentación adjunta',
  'avbe.docs.empty': 'No se ha subido ningún documento al área de patrimonio neto para este período. Súbelos en la pestaña de documentos del panel derecho.',
  'avbe.derived.noDecisionBasis': 'Se han tratado las distribuciones sin base de decisión',
  'avbe.derived.calcDifferences': 'Se han tratado las diferencias de cálculo del estado',
  'avbe.derived.noVoucher': 'Se han tratado los movimientos sin respaldo en justificantes',
  'avbe.derived.directPostings': 'Se han evaluado las contabilizaciones directas en patrimonio neto',
  'avbe.derived.ownerTransactions': 'Se han evaluado las transacciones con propietarios',
  'avbe.derived.negativeEquity': 'Se han tratado las señales de patrimonio neto negativo',
  'avbe.derived.noShareCapital': 'Se ha tratado la falta de capital social contabilizado',
  'avbe.derived.noShareRegister': 'Se ha tratado la falta del libro registro de acciones',
  'avbe.checklist.title': 'Lista de comprobación profesional',
  'avbe.checklist.titleReadOnly': 'Lista de comprobación profesional (del responsable de la ejecución, solo lectura)',
  'avbe.checklist.none': 'No hay puntos de control definidos para el patrimonio neto en este período.',
  'avbe.checklist.note': 'Los puntos se aplican a toda el área de patrimonio neto. Una marca se guarda en todas las cuentas de patrimonio neto del período.',
  'avbe.checklist.groupItems': 'Asuntos que requieren tratamiento',
  'avbe.checklist.countOf': '{done} de {total}',
  'avbe.checklist.handledOf': '{done} de {total} tratados',
  'avbe.checklist.notApplicable': 'No aplica en este período',
  'avbe.checklist.followsAssessments': 'Se deriva de las evaluaciones',
  'avbe.checklist.groupAssessments': 'Evaluaciones profesionales generales',
  'avbe.checklist.groupReady': 'Preparación para la revisión',
  'avbe.checklist.performedBy': 'Realizado por {name}',
  'avbe.checklist.doneOfTotal': '{done} de {total} puntos de control completados',
  'avbe.blocker.distOne': 'Falta la base de decisión documentada en una distribución',
  'avbe.blocker.distMany': 'Falta la base de decisión documentada en {count} distribuciones',
  'avbe.blocker.deviates': 'El patrimonio neto calculado difiere del contabilizado',
  'avbe.blocker.assessmentUndocumented': 'La evaluación del patrimonio neto y la liquidez no está documentada',
  'avbe.blocker.checkpointOne': 'Queda {count} punto de control',
  'avbe.blocker.checkpointMany': 'Quedan {count} puntos de control',
  'avbe.conclusion.title': 'Conclusión y aprobación',
  'avbe.conclusion.changeThisPeriod': 'Variación en este período',
  'avbe.conclusion.unexplainedDiff': 'Diferencia de cálculo sin explicar',
  'avbe.conclusion.transactions': 'Transacciones de patrimonio neto',
  'avbe.conclusion.incompleteCheckpoints': 'Puntos de control sin completar',
  'avbe.conclusion.overallStatus': 'Estado general',
  'avbe.conclusion.notReady': 'No está listo para revisión',
  'avbe.conclusion.ready': 'Listo para revisión',
  'avbe.conclusion.label': 'Conclusión',
  'avbe.conclusion.placeholder': '¿Qué muestra la revisión del patrimonio neto de este período?',
  'avbe.conclusion.remainingRisk': 'Riesgo pendiente',
  'avbe.conclusion.nothingBlocking': 'No queda nada que impida enviar el área a revisión. La app no obtiene el capital social registrado ni los cambios de capital del Foretaksregisteret, y se han comprobado manualmente.',
  'avbe.followup.title': 'Seguimiento del próximo período',
  'avbe.followup.none': 'Ninguna evaluación está marcada para seguimiento en el próximo período.',
  'avbe.followup.badge': 'En seguimiento',
  'avbe.followup.actionLine': 'Medida: {action}',
  'avbe.followup.noAction': 'Sin medidas anotadas',
  'avbe.followup.due': 'Plazo {date}',
  'avbe.followup.open': 'Abrir evaluación',
  'avbe.conclusion.send': 'Enviar el área a revisión',
  'avbe.conclusion.oneThingLeft': 'Queda una cosa pendiente antes de poder enviar el área.',
  'avbe.conclusion.thingsLeft': 'Quedan {count} cosas pendientes antes de poder enviar el área.',
  'avbe.assessments.notAssessed': 'Sin evaluar',
  'avbe.assessments.decisionDocumented': 'Base de decisión recibida y verificada',
  'avbe.assessments.decisionRequested': 'Base de decisión pendiente de obtener del cliente',
  'avbe.assessments.appropriationToBook': 'La aplicación del resultado debe contabilizarse',
  'avbe.assessments.reclassWithinEquity': 'Reclasificar dentro del patrimonio neto',
  'avbe.assessments.reclassToDebt': 'Reclasificar a deuda o a crédito',
  'avbe.assessments.capitalChange': 'El cambio de capital debe registrarse',
  'avbe.assessments.assessedWithBoard': 'Patrimonio neto y liquidez evaluados con el consejo de administración',
  'avbe.assessments.noCorrection': 'No hace falta corregir',
  'avbe.assessments.wrongBooking': 'Contabilización errónea: se corrige',
  'avbe.assessments.awaitingDocs': 'A la espera de documentación',
  'avbe.assessments.awaitingClient': 'A la espera del cliente',
  'avbe.followUpNext': 'Seguimiento en el próximo período',
  'avbe.close': 'Cerrar',
  'avbe.drawer.appliesTo': 'Se refiere a',
  'avbe.drawer.rationaleRequired': 'Justificación profesional (obligatoria)',
  'avbe.drawer.rationale': 'Justificación profesional',
  'avbe.drawer.rationalePlaceholder': '¿A qué se refiere el asunto y en qué se basa la evaluación? Remite al acta, al acuerdo o al justificante.',
  'avbe.drawer.actionPlaceholder': 'P. ej.: obtener el acta de la junta general o corregir el justificante',
  'avbe.drawer.followUpDue': 'Plazo de seguimiento',
  'avbe.drawer.needsComment': 'Esta evaluación requiere una justificación.',
  'avbe.drawer.save': 'Guardar evaluación',
});
